<template>
  <div id="sj">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'sj'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/exhibition/booth/time/Time.vue